<template>
  <div class="container">
    <div class="header commonCardWidth">
      <img src="@/assets/images/logo.png" class="logo" alt="" />
      <el-dropdown placement="bottom" @command="changeLan">
        <div class="languageContainer">
          {{ lang == "en" ? "English" : "Tiếng Việt" }}
          <span class="el-dropdown-link">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
        </div>
        <el-dropdown-menu slot="dropdown" style="width: 148px">
          <el-dropdown-item command="en">English</el-dropdown-item>
          <el-dropdown-item command="vi">Tiếng Việt</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="commonPad card1">
      <img src="@/assets/images/pic3_m.png" class="bgImg mobileShow" />
      <img src="@/assets/images/pic3.png" class="bgImg pcShow" />
      <div class="leftArea commonCardWidth">
        <div class="titleText card1Width">
          <span v-if="lang == 'en'">
            Connect<br />
            from the heart
          </span>
          <span v-else>{{ textObj[lang].area1.title2 }}</span>
        </div>
        <div class="cardContent card1Width2">
          {{ textObj[lang].area1.content }}
        </div>
        <div class="btns">
          <el-popover placement="bottom" width="210" trigger="hover">
            <!-- <img src="@/assets/code.png" class="codeImg" /> -->
            <qrcode :value="downloadUrl.ios" :options="{ width: 210 }" />
            <div
              class="commonBtn"
              slot="reference"
              @click="goDownload(downloadUrl.ios, 'ios')"
            >
              <img src="@/assets/images/ic_apple.png" alt="" />
              <div>
                <div class="btnText1">Download on the</div>
                <div class="btnText2">App Store</div>
              </div>
            </div>
          </el-popover>
          <el-popover placement="bottom" width="210" trigger="hover">
            <!-- <img src="@/assets/code.png" class="codeImg" /> -->
            <qrcode :value="downloadUrl.android" :options="{ width: 210 }" />
            <div
              class="commonBtn"
              slot="reference"
              @click="goDownload(downloadUrl.android, 'android')"
            >
              <img src="@/assets/images/ic_android.png" alt="" />
              <div>
                <div class="btnText1">Get it on</div>
                <div class="btnText2">Android</div>
              </div>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <!-- 会动的一堆人 -->
    <div class="commonPad">
      <img src="@/assets/images/bg2.png" class="bgImg mobileShow" />
      <img src="@/assets/images/bg.png" class="bgImg pcShow" />
      <div class="centerArea">
        <div>Whatever You’re Looking For</div>
        <span>You’ll Find It</span> Here.
      </div>
      <div
        v-for="(item, index) in headList"
        :key="item.img"
        :class="[`avatar-` + (index + 1), 'avatar']"
      >
        <img :src="item.img" class="avatarImg" />
        <div
          v-if="item.text"
          class="textBox"
          :class="{ voiceBox: item.style2 }"
        >
          {{ item.text }}
        </div>
        <div v-if="item.voice" class="voiceBox">
          {{ item.voice }}
          <img src="@/assets/images/icon_voice_right.png" class="voiceBoxImg" />
        </div>
      </div>
    </div>
    <!-- why choose -->
    <div class="commonPad">
      <div class="halfArea">
        <div class="mobileHalfTitle mobileShow">
          {{ textObj[lang].area2.title }}
          <span>{{ appName }}</span
          >?
        </div>
        <div class="halfAreaContent">
          <img src="@/assets/images/pic_girl.png" class="bgImg" />
          <div class="checkLine">
            <img src="@/assets/images/ic_checked.png" class="checkLineImg" />
            <span>Hương,28</span>
          </div>
          <div class="threeBox">
            <div>
              <div class="boxCard">
                <img src="@/assets/images/ic_coffee.png" class="boxCardImg" />
                <span>{{ textObj[lang].date }}</span>
              </div>
            </div>
            <div>
              <div class="boxCard">
                <img src="@/assets/images/ic_xin.png" class="boxCardImg" />
                <span>{{ textObj[lang].relationship }}</span>
              </div>
            </div>
            <div>
              <div class="boxCard">
                <img src="@/assets/images/ic_chat.png" class="boxCardImg" />
                <span>{{ textObj[lang].chat }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="halfAreaContent">
          <div class="rightArea">
            <div class="rightAreaTitle pcShow">
              {{ textObj[lang].area2.title }}
              <span>{{ appName }}</span
              >?
            </div>
            <div class="rightArea-content">
              {{ textObj[lang].area2.content1 }}
            </div>
            <div class="rightArea-content">
              {{ textObj[lang].area2.content2 }}
            </div>

            <div class="downloadBtn" @click="downApk">Download</div>
          </div>
        </div>
      </div>
    </div>
    <div class="commonPad blueArea">
      <div class="commonCardWidth">
        <div class="blueLeftText">
          <div v-if="lang == 'en'">
            Keep <span style="color: #ffff8f">Life’s Memories.</span><br />
            Share the Magic of <br />
            Every Moment.
          </div>
          <div v-else>
            Giữ lại những <span style="color: #ffff8f">Khoảnh khắc</span> trong
            <br />
            cuộc sống.<br />
            Chia sẻ những điều kỳ diệu <br />
            của từng giây phút.
          </div>
        </div>
        <img src="@/assets/images/pic_girl2.png" class="blueAreaImg" />
      </div>
    </div>
    <div class="footer">
      <div class="commonCardWidth first">
        <div class="line1">
          <div class="line1title">
            About <span>{{ appName }}</span>
          </div>
          <div class="line1text">
            <a
              :href="
                lang === 'en'
                  ? 'https://www.yameapp.com/terms/v1.0/1_0_rechargeAgreement_en.html'
                  : 'https://www.yameapp.com/terms/v1.0/1_0_rechargeAgreement_vn.html'
              "
              target="_blank"
              class="aboutLink"
              >{{ textObj[lang].footer.line1.text1 }}</a
            >
            <el-divider direction="vertical" class="aboutLine" />
            <a
              :href="
                lang === 'en'
                  ? 'https://www.yameapp.com/terms/v1.0/1_0_userAgreement_en.html'
                  : 'https://www.yameapp.com/terms/v1.0/1_0_userAgreement_vn.html'
              "
              target="_blank"
              class="aboutLink"
              >{{ textObj[lang].footer.line1.text2 }}</a
            >
            <el-divider
              direction="vertical"
              style="margin: 0"
              class="aboutLine"
            />
            <a
              :href="
                lang === 'en'
                  ? 'https://www.yameapp.com/terms/v1.0/1_0_privacyPolicy_en.html'
                  : 'https://www.yameapp.com/terms/v1.0/1_0_privacyPolicy_vn.html'
              "
              target="_blank"
              class="aboutLink"
              >{{ textObj[lang].footer.line1.text3 }}</a
            >
          </div>
        </div>
        <div class="line2">
          {{ textObj[lang].footer.line2 }}
        </div>
      </div>
      <el-divider />
      <div class="commonCardWidth second">
        <div class="second-text1">
          {{ textObj[lang].footer.emailText }}: yameappcom@gmail.com
        </div>
        <div class="delBtn" @click="showDeleteDialog">
          {{ textObj[lang].footer.deleteText }}
        </div>
      </div>
    </div>

    <el-dialog
      :title="textObj[lang].footer.deleteText"
      :visible.sync="showDelete"
      :width="isMobile ? '300px' : '600px'"
      @close="showDelete = false"
    >
      <el-input
        type="email"
        v-model="username"
        style="margin-bottom: 20px"
        :placeholder="lang == 'en' ? 'Enter Account' : 'Nhập tài khoản'"
      />
      <el-input
        type="number"
        v-model="verifyCode"
        maxlength="4"
        :placeholder="
          lang == 'en' ? 'Enter Verification Code' : 'Nhập mã xác minh'
        "
      >
        <template slot="append">
          <el-button
            v-if="countdown == 0"
            @click="sendEmailCode"
            type="primary"
          >
            {{ lang == "en" ? "Get Code" : "Nhận mã" }}
          </el-button>
          <el-button v-if="countdown > 0"> {{ countdown }} S </el-button>
        </template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDelete = false">
          {{ textObj[lang].cancel }}
        </el-button>
        <el-button
          type="primary"
          :loading="btnLoading"
          @click="deleteAccount"
          style="background-color: #0067ff"
          >{{ lang == "en" ? "Confirm Deletion" : "Xác nhận xóa" }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { serverApi } from "@/server/index";
import { AestheticFluidBg } from "@/utils/AestheticFluidBg.js";
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  name: "home",
  components: {
    qrcode: VueQrcode,
  },
  data() {
    return {
      textObj: {
        en: {
          area1: {
            title:
              "Online chat brings us together to share the wonders of the world.",
            title2: "Connect from the heart",
            content:
              "Real-Time Connections—Via Voice, Video & Text.Step into a vibrant, welcoming space where emotions flow freely and friendships begin.",
          },
          area2: {
            title: "Why Choose",
            content1:
              "Join a vibrant community of real, active users.In Yame’s social space, you’re free to express every emotion —",
            content2:
              "joy, excitement, loneliness, sadness,and even those unexpected, sweet encounters.",
          },
          date: "Date",
          chat: "Chat",
          relationship: "Relationship",
          footer: {
            line1: {
              text1: "Recharge agreement",
              text2: "User agreement",
              text3: "Privacy policy",
            },
            line2:
              "Yame is a mobile social networking platform targeted at the Vietnamese region, making your social chats easy and fun. Yame offers features such as text, voice, and video chat.",
            deleteText: "Delete account",
            emailText: "Contact us Email",
          },
          cancel: "Cancel",
        },
        vi: {
          area1: {
            title:
              "Trò chuyện trực tuyến giúp chúng ta gặp gỡ và chia sẻ những kỳ quan của thế giới.",
            title2: "Kết nối từ trái tim",
            content:
              "Kết nối thời gian thực—qua thoại, video và văn bản.Bước vào một không gian đầy sức sống, đầy niềm vui và đầy tình bạn nơi những cảm xúc chảy trôi tự do và những tình bạn bắt đầu.",
          },
          area2: {
            title: "Tại sao chọn",
            content1:
              "Tham gia cộng đồng sôi động, đầy hoạt động của những người dùng thực sự.Trong không gian xã hội của Yame, bạn có thể thể hiện mọi cảm xúc của mình —",
            content2:
              "hạnh phúc, hào hứng, cô đơn, buồn và thậm chí cả những cuộc gặp gỡ ngọt ngào bất ngờ.",
          },
          date: "Ngày",
          relationship: "Mối quan hệ",
          chat: "Tin nhắn",
          footer: {
            line1: {
              text1: "Thỏa thuận nạp tiền",
              text2: "Thỏa thuận người dùng",
              text3: "Chính sách bảo mật",
            },
            line2:
              "Yame là nền tảng mạng xã hội di động hướng đến khu vực Việt Nam, giúp những cuộc trò chuyện xã hội của bạn trở nên dễ dàng và vui vẻ. Yame cung cấp các tính năng như trò chuyện văn bản, thoại và video.",
            deleteText: "Xóa tài khoản",
            emailText: "Liên hệ Email",
          },
          cancel: "Hủy",
        },
      },
      appName: "Yame",
      isPc: true,
      versonInfo: {},
      lang: "en",
      isShow: false,
      showDelete: false,
      username: "",
      verifyCode: "",
      countdown: 0,
      timer: null,
      headList: [
        {
          img: require("@/assets/images/head5.png"),
        },
        {
          img: require("@/assets/images/head1.png"),
          text: "Xin chào",
          style2: true,
        },
        {
          img: require("@/assets/images/head6.png"),
          text: "Hello!~",
        },
        {
          img: require("@/assets/images/head9.png"),
          voice: 15,
        },
        {
          img: require("@/assets/images/head10.png"),
          text: "Hello Bro",
          style2: true,
        },
        {
          img: require("@/assets/images/head2.png"),
          text: "Bonjour",
        },
        {
          img: require("@/assets/images/head3.png"),
          text: "สวัสดี",
        },
        {
          img: require("@/assets/images/head4.png"),
        },
        {
          img: require("@/assets/images/head11.png"),
          text: "Hola！",
        },
        {
          img: require("@/assets/images/head8.png"),
        },
        {
          img: require("@/assets/images/head7.png"),
        },
      ],
      downloadUrl: {
        android:
          "https://play.google.com/store/apps/details?id=com.kaigongdajibs.app",
        ios: "https://apps.apple.com/us/app/yame-b%C3%BAt-k%C3%AD-x%C3%A3-h%E1%BB%99i/id6742023134?l=zh-Hans-CN",
      },
      btnLoading: false,
    };
  },
  created() {
    if (this.isMobile) {
      this.isPc = false;
      console.log("移动端");
    } else {
      this.isPc = true;
      console.log("PC端");
    }
    this.lang = localStorage.getItem("lang") || "en";
    this.getVerson();
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  mounted() {
    // 页面加载完成后上报 viewHome
    // if (window.ttq) {
    //   // 页面加载触发 PII
    //   const email = "";
    //   const phone = "";
    //   const externalId = "";
    //   window.ttq.identify({
    //     email: email ? sha256(email).toString() : undefined,
    //     phone_number: phone ? sha256(phone).toString() : undefined,
    //     external_id: externalId ? sha256(externalId).toString() : undefined,
    //   });
    //   window.ttq.track("viewHome", {});
    // }
  },

  methods: {
    goDownload(url, type) {
      // console.log("url :>> ", url);
      // if (type === "ios") {
      //   // 触发 TikTok Pixel 下载事件
      //   if (window.ttq) {
      //     // window.ttq.track("Download", { os: "iOS" });
      //     window.ttq.track("Download", {
      //       contents: [
      //         {
      //           content_type: "iOS",
      //         },
      //       ],
      //     });
      //   }
      // } else if (type === "android") {
      //   if (window.ttq) {
      //     // window.ttq.track("Download", { os: "Android" });
      //     window.ttq.track("Download", {
      //       contents: [
      //         {
      //           content_type: "Android",
      //         },
      //       ],
      //     });
      //   }
      // }
      this.isMobile && window.open(url);
    },
    async downApk() {
      window.scrollTo(0, 0);
      // serverApi.requestApi("get", "/app/open/getNewVersion").then((res) => {
      //   if (res.data.data) {
      //     window.location.href = res.data.t_download_url;
      //   } else {
      //     this.$message("no more apk");
      //   }
      // });
    },
    async sendEmailCode() {
      if (this.username == "") {
        this.$toast.center(
          this.lang == "en" ? "Enter Account" : "Nhập tài khoản"
        );
        return;
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(this.username)) {
        this.$toast.center(
          this.lang == "en"
            ? "Email account format error"
            : "Lỗi định dạng tài khoản email"
        );
        return;
      }
      let param = {
        type: "LOGIN_ABROAD",
        email: this.username,
      };
      const { data } = await serverApi
        .requestApi("post", "/mail/open/sendSms", param)
        .then();
      if (data.status != 1) return;
      // 启动倒计时
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    async deleteAccount() {
      if (this.username == "") {
        this.$toast.center(
          this.lang == "en" ? "Enter Account" : "Nhập tài khoản"
        );
        return;
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(this.username)) {
        this.$toast.center(
          this.lang == "en"
            ? "Email account format error"
            : "Lỗi định dạng tài khoản email"
        );
        return;
      }
      if (this.verifyCode == "") {
        this.$toast.center(
          this.lang == "en" ? "Enter Verification Code" : "Nhập mã xác minh"
        );
        return;
      }
      let param = {
        type: "EMAIL",
        account: this.username,
        code: this.verifyCode,
      };
      this.btnLoading = true;
      const { data } = await serverApi
        .requestApi("post", "/personal/open/deleteAbroadAccount", param)
        .then();
      if (data.status == 1) {
        this.$toast.center(
          this.lang == "en" ? "Deleted successfully" : "đã xóa thành công"
        );
        this.showDelete = false;
      } else {
        this.$toast.center(data.message);
      }
      this.btnLoading = false;
    },
    async getVerson() {
      const { data } = await serverApi
        .requestApi("get", "/app/open/getNewVersion")
        .then();
      this.versonInfo = data.data;
    },
    goAppsotre() {
      window.location.href =
        "itms-apps://itunes.apple.com/cn/app/id${appleId}?mt=8";
    },
    changeLan(lang) {
      console.log(lang);
      this.lang = lang;
      localStorage.setItem("lang", lang);
    },
    showDeleteDialog() {
      this.username = "";
      this.verifyCode = "";
      this.btnLoading = false;
      this.showDelete = !this.showDelete;
    },
    showModal() {
      this.isShow = !this.isShow;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@font-face {
  font-family: "Poppins-Bold";
  src: url("../assets/font/Poppins-Bold.ttf");
}
@font-face {
  font-family: "Poppins-Medium";
  src: url("../assets/font/Poppins-Medium.ttf");
}
@font-face {
  font-family: "Poppins-Regular";
  src: url("../assets/font/Poppins-Regular.ttf");
}
@font-face {
  font-family: "Poppins-SemiBold";
  src: url("../assets/font/Poppins-SemiBold.ttf");
}

.commonCardWidth {
  /* width: 100%; */
  /* padding: 0 240px; */
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 120px;
  @media screen and (max-width: 1920px) {
    padding: 0 240px;
  }
  @media screen and (max-width: 1680px) {
    padding: 0 220px;
  }
  @media screen and (max-width: 1440px) {
    padding: 0 200px;
  }
  @media screen and (max-width: 1300px) {
    padding: 0 180px;
  }
  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
}

.logo {
  width: 135px;
  @media screen and (max-width: 768px) {
    width: 80px;
  }
}
.container {
  width: 100%;
  min-height: 100vh;
  background-color: #f1f8ff;
  box-sizing: content-box;
}
.header {
  /* width: 100%; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  @media screen and (max-width: 768px) {
    height: 50px;
  }
}
.languageContainer {
  border: 1px solid #000;
  border-radius: 99px;
  width: 108px;
  height: 47px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-size: 18px;
  color: #000;
  @media screen and (max-width: 768px) {
    font-size: 13px;
    padding: 0 10px;
    width: 80px;
    height: 30px;
  }
}

.card1 {
  color: #fff;
  position: relative;
  box-sizing: border-box;
  padding: 0 35px;
  @media screen and (max-width: 768px) {
    padding: 0 16px;
  }
}
.leftArea {
  position: absolute;
  left: 0;
  right: 0;
  top: 15%;
  @media screen and (max-width: 768px) {
    left: 15px;
    /* top: 35%; */
    top: inherit;
    bottom: 108px;
  }
}
.mobileShow {
  display: none !important;
  @media screen and (max-width: 768px) {
    display: block !important;
  }
}
.pcShow {
  display: block !important;
  @media screen and (max-width: 768px) {
    display: none !important;
  }
}

.card1Width {
  width: 50%;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
.card1Width2 {
  width: 45%;
  @media screen and (max-width: 1920px) {
    width: 55%;
  }
  @media screen and (max-width: 1680px) {
    width: 60%;
  }
  @media screen and (max-width: 1440px) {
    width: 75%;
  }
  @media screen and (max-width: 1300px) {
    width: 90%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
.titleText {
  font-size: 74px;
  /* font-size: 68px; */
  line-height: 88px;
  font-family: "Poppins-Medium";
  @media screen and (max-width: 1680px) {
    font-size: 54px;
    line-height: 78px;
  }
  @media screen and (max-width: 1440px) {
    font-size: 48px;
    line-height: 60px;
  }
  @media screen and (max-width: 1300px) {
    font-size: 38px;
    line-height: 50px;
  }
  @media screen and (max-width: 768px) {
    font-size: 24px;
    line-height: 24px;
  }
}
.cardContent {
  margin-top: 48px;
  font-size: 36px;
  font-family: "Poppins-Regular";
  @media screen and (max-width: 1680px) {
    margin-top: 36px;
    font-size: 24px;
  }
  @media screen and (max-width: 1440px) {
    font-size: 18px;
  }
  @media screen and (max-width: 1300px) {
    font-size: 16px;
  }
  @media screen and (max-width: 768px) {
    margin-top: 8px;
    font-size: 12px;
    line-height: 13px;
  }
}
.btns {
  display: flex;
  margin-top: 8%;
  @media screen and (max-width: 768px) {
    position: absolute;
    left: 15px;
    right: inherit;
    bottom: -80px;
  }
}
.commonBtn {
  width: 220px;
  height: 86px;
  display: flex;
  align-items: center;
  background-color: #000;
  color: #fff;
  padding: 0 9px;
  margin-right: 18px;
  border-radius: 11px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    width: 128px;
    height: 54px;
    padding: 0 5px;
  }
}
.btnText1 {
  font-size: 16px;
  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
}
.btnText2 {
  font-size: 24px;
  font-family: "Poppins-SemiBold";
  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
}
.commonBtn img {
  width: 56px;
  height: 56px;
  margin-right: 9px;
  @media screen and (max-width: 768px) {
    width: 34px;
    height: 34px;
    margin-right: 5px;
  }
}
.codeImg {
  width: 210px;
}

.centerArea {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 50%;
  margin-top: -65px;
  font-size: 48px;
  text-align: center;
  font-family: "Poppins-Medium";
  span {
    color: #0067ff;
  }
  @media screen and (max-width: 1300px) {
    font-size: 40px;
  }
  @media screen and (max-width: 768px) {
    width: 300px;
    font-size: 18px;
    margin-top: -30px;
  }
}

.avatarImg {
  @media screen and (max-width: 768px) {
    width: 57px !important;
    height: 57px !important;
  }
}
.textBox {
  background-color: #fff;
  display: inline-block;
  /* margin-left: -20px;
    margin-top: 30px; */
  position: absolute;
  bottom: -20px;
  right: -30px;
  border-radius: 5px 10px 10px 10px;
  line-height: 40px;
  padding: 0 8px;
  @media screen and (max-width: 768px) {
    line-height: 18px;
    font-size: 10px;
    padding: 0 3px;
    bottom: -10px;
  }
}
.voiceBox {
  background-color: #0168fe;
  color: #fff;
  display: inline-flex;
  position: absolute;
  bottom: -5px;
  left: -80px;
  border-radius: 12px 4px 12px 12px;
  line-height: 40px;
  width: 85px;
  padding: 0 8px;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 768px) {
    left: -40px;
    width: 45px;
    line-height: 18px;
    font-size: 10px;
    padding: 0 3px;
  }
}
.voiceBoxImg {
  width: 24px;
  height: 24px;
  @media screen and (max-width: 768px) {
    width: 12px;
    height: 12px;
  }
}

.commonPad {
  position: relative;
  width: 100%;
  .bgImg {
    width: 100%;
    display: block;
  }
}
.halfArea {
  display: flex;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    background-color: #c8e0ff;
  }
}
.halfAreaContent {
  width: 50%;
  position: relative;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
.mobileHalfTitle {
  line-height: 92px;
  font-size: 24px;
  padding-left: 26px;
  font-family: "Poppins-Medium";
  span {
    color: #0067ff;
  }
}
.checkLine {
  position: absolute;
  left: 46px;
  top: 57px;
  font-size: 48px;
  font-family: "Poppins-Bold";
  font-weight: bold;
  color: #fff;
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    top: 15px;
    left: 26px;
    font-size: 20px;
  }
}
.checkLineImg {
  width: 40px;
  margin-right: 16px;
  @media screen and (max-width: 768px) {
    width: 21px;
    margin-right: 8px;
  }
}
.threeBox {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-250px);
  font-family: "Poppins-Medium";
  @media screen and (max-width: 768px) {
    top: inherit;
    bottom: 28px;
    transform: translateX(0);
    left: 26px;
  }
}
.boxCard {
  background-color: rgba(255, 255, 255, 0.77);
  height: 82px;
  display: inline-flex;
  align-items: center;
  padding: 0 25px;
  font-size: 32px;
  font-weight: bold;
  border-radius: 14px;
  margin-bottom: 34px;
  @media screen and (max-width: 1300px) {
    height: 70px;
    font-size: 28px;
  }
  @media screen and (max-width: 768px) {
    padding: 0 5px;
    font-size: 12px;
    height: 30px;
    margin-bottom: 10px;
    border-radius: 4px;
  }
}
.boxCardImg {
  width: 44px;
  margin-right: 22px;
  @media screen and (max-width: 1300px) {
    width: 38px;
  }
  @media screen and (max-width: 768px) {
    width: 18px;
    margin-right: 10px;
  }
}
.rightArea {
  margin: 0 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 70%;
  height: 100%;
  font-family: "Poppins-Regular";

  @media screen and (max-width: 768px) {
    margin: 0;
    padding: 22px 30px;
    width: 100%;
    box-sizing: border-box;
    height: 196px;
    justify-content: space-around;
  }
}
.downloadBtn {
  border-radius: 999px;
  padding: 0 40px;
  line-height: 71px;
  border: 1px solid #0067ff;
  font-size: 24px;
  font-weight: bold;
  color: #266bdc;
  display: inline-block;
  cursor: pointer;
  width: auto;
  @media screen and (max-width: 768px) {
    display: none;
    /* font-size: 12px;
    padding: 0 20px;
    line-height: 20px; */
  }
}
.rightArea-content {
  margin-bottom: 10%;
  font-size: 24px;
  @media screen and (max-width: 768px) {
    font-size: 12px;
    line-height: 24px;
    margin-bottom: 8px;
  }
}
.rightAreaTitle {
  /* margin-top: 18%; */
  margin-bottom: 9%;
  font-size: 54px;
  font-family: "Poppins-Medium";
  @media screen and (max-width: 1300px) {
    font-size: 46px;
  }
  @media screen and (max-width: 768px) {
    /* margin-top: 10px; */
    margin-bottom: 10px;
    font-size: 14px;
  }
  span {
    color: #0067ff;
  }
}

.blueArea {
  background-color: #266bdc;
  .commonCardWidth {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media screen and (max-width: 768px) {
    overflow: hidden;
    height: 331px;
  }
}
.blueAreaImg {
  width: 50%;
  @media screen and (max-width: 768px) {
    width: 100%;
    position: absolute;
    right: -20%;
    bottom: -10%;
  }
}
.blueLeftText {
  height: 100%;
  color: #fff;
  font-size: 54px;
  width: 50%;
  /* font-weight: bold; */
  font-family: "Poppins-Medium";
  @media screen and (max-width: 1440px) {
    font-size: 46px;
  }
  @media screen and (max-width: 1300px) {
    font-size: 40px;
  }
  @media screen and (max-width: 768px) {
    width: 70%;
    font-size: 22px;
    position: absolute;
    left: 30px;
    top: 43px;
    z-index: 1;
  }
}
.second {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 115px;
  padding-bottom: 24px;
  font-size: 24px;
  @media screen and (max-width: 768px) {
    margin-top: -24px;
    height: 85px;
    padding-bottom: 0;
  }
}
.second-text1 {
  font-family: "Poppins-SemiBold";
  @media screen and (max-width: 768px) {
    font-size: 12px;
    width: 60%;
  }
}
.delBtn {
  border-radius: 999px;
  padding: 0 20px;
  line-height: 56px;
  border: 1px solid #0067ff;
  font-size: 24px;
  font-family: "Poppins-Medium";
  color: #266bdc;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    font-size: 13px;
    line-height: 36px;
    padding: 0 14px;
  }
}
.line1 {
  padding-top: 63px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 23px;
  @media screen and (max-width: 768px) {
    padding-top: 33px;
    margin-bottom: 10px;
    flex-direction: column;
    align-items: flex-start;
  }
}
.line1title {
  font-size: 54px;
  /* font-weight: bold; */
  padding-right: 10%;
  font-family: "Poppins-Medium";

  @media screen and (max-width: 1440px) {
    font-size: 46px;
    padding-right: 8%;
  }
  @media screen and (max-width: 768px) {
    font-size: 24px;
    padding-right: 10px;
  }
  span {
    color: #0067ff;
  }
}
.line1text {
  flex: 1;
  font-weight: bold;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  letter-spacing: -1px;
  @media screen and (max-width: 1440px) {
    font-size: 20px;
  }
  @media screen and (max-width: 768px) {
    margin-top: 30px;
    font-size: 14px;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}
.aboutLink {
  color: #266bdc;
  text-decoration: none;
  font-family: "Poppins-Medium";
  @media screen and (max-width: 768px) {
    display: inline-block;
    width: 50%;
    text-decoration: underline;
    margin-bottom: 33px;
  }
}
.aboutLine {
  @media screen and (max-width: 768px) {
    display: none;
  }
}
.line2 {
  padding-bottom: 49px;
  color: #666666;
  font-size: 24px;
  font-family: "Poppins-Regular";

  @media screen and (max-width: 768px) {
    font-size: 14px;
    padding-bottom: 0;
  }
}

.choseContianer {
  width: 160px;
  height: 100px;
  border-radius: 8px;
  border: 1px solid #fff;
  position: absolute;
  top: 47px;
  left: 0;
  /* right: 120px; */
}

/* ==========动画====== */

.avatar {
  position: absolute;
  /* right: 50%;
  top: 50%;
  transform: translateY(-50%); */
  border-radius: 50%;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #1f1f1f;
  > img {
    width: 115px;
  }
  &:hover {
    transform: scale(1.2);
  }
}

/* 应用动画到头像 */
.avatar-1 {
  left: 10%;
  top: 10%;
  img {
    width: 88px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.avatar-2 {
  left: 27%;
  top: 17%;
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.avatar-3 {
  left: 50%;
  top: 10%;
  margin-left: -60px;
  img {
    width: 95px;
  }
  @media screen and (max-width: 768px) {
    left: inherit;
    right: 32px;
  }
}

.avatar-4 {
  right: 25%;
  top: 12%;
  @media screen and (max-width: 768px) {
    left: 79px;
    right: inherit;
    transform: scale(0.9);
  }
}

.avatar-5 {
  right: 5%;
  top: 15%;
  img {
    width: 96px;
  }
  @media screen and (max-width: 768px) {
    top: inherit;
    right: 63px;
    bottom: 103px;
  }
}

.avatar-6 {
  left: 13%;
  bottom: 25%;
}

.avatar-7 {
  left: 30%;
  bottom: 8%;
  img {
    width: 122px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.avatar-8 {
  left: 45%;
  bottom: 22%;
  img {
    width: 140px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.avatar-9 {
  right: 30%;
  bottom: 25%;
  img {
    width: 95px;
  }
  @media screen and (max-width: 768px) {
    right: inherit;
    left: 93px;
    bottom: 52px;
    transform: scale(0.8);
  }
}

.avatar-10 {
  right: 17%;
  bottom: 15%;
  img {
    width: 108px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}
.avatar-11 {
  right: 12.5%;
  top: 35%;
  img {
    width: 71px;
  }
  @media screen and (max-width: 768px) {
    left: 112px;
    top: 20%;
    transform: scale(0.9);
  }
}
/* ==========动画======== End */
</style>



// WEBPACK FOOTER //
// src/components/NewHome.vue